import {  HistoryOutlined, HomeOutlined, ContainerOutlined, PicLeftOutlined, PicCenterOutlined ,PlusCircleOutlined } from '@ant-design/icons';

export const useSidebarItems = () => {
    return [
        {
            key: 'main-0',
            label: 'Home',
            icon: <HomeOutlined />,
        },
        {
            key: 'main-1',
            label: 'Request History',
            icon: <HistoryOutlined />,
        },
        {
            key: 'main-2',
            label: 'Marketplace',
            icon: <ContainerOutlined />,
            children: [
                { key: '2.1', label: 'Solvers' },
                { key: '2.2', label: 'Solving Processes' },
            ],
        },
        {
            key: 'main-3',
            label: 'Intermodal Interface Wizard',
            icon: <PicLeftOutlined />,
        },
        {
            key: 'main-4',
            label: 'Workflow Engine',
            icon: <PicCenterOutlined />,
        },
        {
            key: 'main-5',
            label: 'Onboarding',
            icon:<PlusCircleOutlined />,
            children: [
                { key: '5.1', label: 'Solvers' },
                { key: '5.2', label: 'Solving Processes' },
            ],
        },

    ];
};
